
class Utility {
  static bytesToSize (bytes, unit) {
    let sizes = ['M', 'G', 'T']
    let i = parseInt(Math.floor(Math.log(parseInt(bytes)) / Math.log(unit)))
    return bytes / Math.pow(unit, i) + ' ' + sizes[i]
  };
  static bytesToMGb (bytes, fixtoMb) {
    let sizes = ['B', 'K', 'M', 'G', 'T']
    if (parseInt(bytes) === 0) return '0'
    let i = parseInt(Math.floor(Math.log(parseInt(bytes)) / Math.log(1024)))
    if (fixtoMb) {
      i = 2
    }
    return [Math.round((bytes / Math.pow(1024, i)) * 100) / 100, sizes[i]]
  }
}

export default Utility



// WEBPACK FOOTER //
// ./src/util/utility.js